import * as React from "react";
import { prefixer } from "stylis";
import rtlPlugin from "@mui/stylis-plugin-rtl";
import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import { AdapterMomentJalaali } from "@mui/x-date-pickers/AdapterMomentJalaali";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { createTheme, ThemeProvider, useTheme } from "@mui/material/styles";
import { DatePicker } from "@mui/x-date-pickers";

// Create rtl cache
const cacheRtl = createCache({
  key: "adapter-moment-jalali-demo",
  stylisPlugins: [prefixer, rtlPlugin],
});

interface AdapterMomentJalaliProps {
  handleChange?: (value: any) => void;
  valueDate?: any;
  sx?: React.CSSProperties;
  widthProps?: string | number | Record<string, string | number>;
  heightProps?: string | number | Record<string, string | number>;
  errorHandle?: { message?: string };
}

export default function AdapterMomentJalali({
  handleChange,
  valueDate,
  widthProps = "80%",
  sx,
  heightProps = "38px",
  errorHandle,
}: AdapterMomentJalaliProps): React.JSX.Element {
  const existingTheme = useTheme();
  const [open, setOpen] = React.useState(false);

  const theme = React.useMemo(
    () => createTheme(existingTheme, { direction: "rtl" }),
    [existingTheme]
  );

  const handleInputClick = () => {
    setOpen(true);
  };

  return (
    <CacheProvider value={cacheRtl}>
      <ThemeProvider theme={theme}>
        <div dir="rtl" style={{ ...sx }}>
          <LocalizationProvider dateAdapter={AdapterMomentJalaali}>
            <DatePicker
              open={open}
              onClose={() => setOpen(false)}
              onOpen={() => setOpen(true)}
              views={["year", "month", "day"]}
              openTo="year"
              sx={{
                width: widthProps,
                border: "none",
                "& .MuiOutlinedInput-root": {
                  height: heightProps,
                  cursor: "pointer",
                },
                "& .MuiIconButton-root": {
                  color: "#fff",
                },
                "& .MuiPickersInputBase-root": {
                  border: errorHandle?.message
                    ? "1px solid #d32f2f"
                    : "1px solid #444444",
                  borderRadius: "8px",
                  background: "#1e1e1e",
                  height: heightProps,
                  cursor: "pointer",
                },
                "& .MuiInputAdornment-root .MuiSvgIcon-root": {
                  color: "#fff",
                },
                "& .MuiYearCalendar-root .MuiYearCalendar-yearButton": {
                  fontSize: "14px !important",
                },
              }}
              slotProps={{
                textField: {
                  readOnly: true,
                  onClick: handleInputClick,
                },
                desktopPaper: {
                  dir: "rtl",
                  sx: {
                    backgroundColor: "#1E1E1E",
                    "& .MuiPickersCalendarHeader-label": {
                      fontSize: "14px",
                    },
                    "& .MuiPickersMonth-root": {
                      fontSize: "14px",
                    },
                    "& .MuiPickersYear-root": {
                      fontSize: "14px",
                    },
                    "& .MuiYearCalendar-root button": {
                      fontSize: "13px",
                    },
                    "& .MuiMonthCalendar-root button": {
                      fontSize: "13px",
                    },
                  },
                },
                mobilePaper: {
                  dir: "rtl",
                  sx: {
                    backgroundColor: "#1E1E1E",
                    "& .MuiPickersCalendarHeader-label": {
                      fontSize: "14px",
                    },
                    "& .MuiPickersMonth-root": {
                      fontSize: "14px",
                    },
                    "& .MuiPickersYear-root": {
                      fontSize: "14px",
                    },
                  },
                },
              }}
              onChange={handleChange}
              value={valueDate}
            />
          </LocalizationProvider>
        </div>
      </ThemeProvider>
    </CacheProvider>
  );
}